import React from 'react';
import { Navigate } from 'react-router-dom';

// §6.1 — La page-menu à trois tuiles est supprimée.
// « Simulations » ouvre directement le tableau de suivi des dossiers.
export default function SimulationsHubPage() {
  return <Navigate to="/simulations/tableau" replace />;
}
